/** 网关保留顶层字段，勿用作自定义属性名 */
export const ANALYTICS_RESERVED_KEYS = new Set([
  'project_id',
  'event_name',
  'event_id',
  'event_uuid',
  'client_ts',
  'ts',
  't_date',
  'user_id',
  'device_id',
  'account_id',
  'session_id',
  'os',
  'app_version',
  'channel',
  'device_type',
  'ua',
  'ips',
  'bw',
  'la',
  'scre',
  'country',
  'service_code',
  'is_crawler',
  'props_str',
  'props_int',
  'props_float',
  'type',
  'time',
  'distinct_id'
])
